import { useTranslation } from 'next-i18next';
import React, { useContext } from 'react';

import SelectedLocation from '@/modules/periodicJobs/components/SelectedLoactions/SelectedLocation';
import { PeriodicJobsContext } from '@/modules/periodicJobs/context/context';
import { periodicJobsActionsTypes as ActionsTypes } from '@/modules/periodicJobs/context/reducer';
import { IPeriodicJobs } from '@/modules/periodicJobs/types';

const SelectedLoactions = () => {
  const {
    state: { selectedPlots },
    dispatch,
  } = useContext(PeriodicJobsContext);

  const { t } = useTranslation('common');

  const removePlotHandler = (plot: IPeriodicJobs.PlotSchema) => {
    dispatch({ type: ActionsTypes.removePlot, payload: plot });
  };

  return (
    <div className='flex flex-row flex-wrap gap-8'>
      {selectedPlots.map((plot, index) => (
        <SelectedLocation
          key={`${plot.id}-${index}`}
          onClick={() => removePlotHandler(plot)}
        >
          {t('plot')} {plot.number}
        </SelectedLocation>
      ))}
    </div>
  );
};

export default SelectedLoactions;
